import { useMutation } from "@apollo/client";

import { GqlMapEditorFeatureStartImportInput, gql } from "~/__generated__";

import { MAP_EDITOR_LAYER_GET_BY_ID } from "./useMapEditorLayerGetById";

const MAP_EDITOR_IMPORT_START = gql(`
mutation MapEditorImportStart($input: GqlMapEditorFeatureStartImportInput!) {
    mapEditorFeatureImportStart(input: $input) {
      id
      worker
      status
    }
}
`);

export default function useMapEditorImportStart() {
    const [startAddressImportJob, { data, loading, error }] = useMutation(MAP_EDITOR_IMPORT_START, {
        refetchQueries: [MAP_EDITOR_LAYER_GET_BY_ID],
    });

    return {
        startAddressImportJob: (input: GqlMapEditorFeatureStartImportInput) =>
            startAddressImportJob({
                variables: { input },
            }),
        loading,
        error,
        data: data?.mapEditorFeatureImportStart,
    };
}
